/**
 * Documentation sections — the single source shared by the sidebar nav (App.tsx)
 * and the /docs content router (DocsPage.tsx). Slugs are the route contract
 * (/docs/:section) and the keys of DocsPage's element map.
 */
export const DOC_SECTIONS = [
  { slug: 'get-started', label: 'Get started', blurb: 'Connect your AI agent' },
  { slug: 'request-access', label: 'Requesting access', blurb: 'Ask for a resource' },
  { slug: 'mcp', label: 'MCP tools', blurb: 'Agent tool reference' },
  { slug: 'agents', label: 'Agents', blurb: 'Node fleet & Atlas IPs' },
] as const;

export type DocSlug = (typeof DOC_SECTIONS)[number]['slug'];
